<template>

  <ModalContainer queryParam="msp" ref="modalContainer" size="xl">
    <b-card style="border: 1px solid #ccc;">
      <h4 class="text-center mb-2">Informacion de MSP</h4>

      <div 
        v-for="titular in itemsToMsp" 
        :key="titular.id"
      >

        <LoadFileInput
          v-model="titular.newMsp"
          :label="titular.nombre"
          :urlFile="titular.urlMsp"
          @eliminado="handlerEliminado"
        />

        <hr>
      </div>
      

      <div class="d-flex justify-content-end">

        <b-button 
          variant="success"
          @click="onSaveMsp"
          
        >
          Guardar Cambios
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
  
</template>

<script>
import { titularService, fileService } from '@/shared/services';
import { LoadFileInput, ModalContainer }  from '@/shared/components';
import { procedimientosService }  from '../services';

export default {

  name: "LoadMsp",

  components: {
    LoadFileInput,
    ModalContainer
  },

  created() {
    this.loadData();
  },

  data() {
    return {
      itemsToMsp: [],
      urlsMspsDelete : [],
      dataFilesToUpdate: null,

      tokenProceso: null,

      metaData:{
        pacienteId     : null,
        nombrePaciente : null,
        proceso        : null
      }

    };
  },

  methods: {

    async loadData(){
      await this.loadDataLab();
      await this.lodaDataMsp();
    },

    handlerEliminado(valor){
      if(valor.url){
        this.urlsMspsDelete.push(valor.url)
      }
    },


    async loadDataLab(){
      this.tokenProceso = this.$route.query.msp;
      if(!this.tokenProceso) return;
      const responseProceso = await procedimientosService.getByToken(this.tokenProceso);
      if(!responseProceso) return;
      const dataPaciente = responseProceso.consultamedica.cita.paciente;
      const dataCita = responseProceso.consultamedica.cita;
      const dataProceso  = responseProceso.procedimiento;
      this.metaData = {
        pacienteId     : dataPaciente.id,
        nombrePaciente : `${dataPaciente.persona.identificacion} - ${dataPaciente.persona.primerApellido} ${dataPaciente.persona.primerNombre}`,
        proceso        : `${dataProceso.codigo} - ${dataProceso.descripcion}`,
        cita           : dataCita
      }
    },
    
    async lodaDataMsp(){
      if(!this.metaData.pacienteId) return;
      const responseTitulares = await titularService.getTitularesByIdCita(this.metaData.cita.id);
      let personasToMsp = []
      try{
       let titulares = JSON.parse(responseTitulares.titulares)
       if(titulares && titulares.length) {
        titulares.forEach(element => {
        personasToMsp.push({nombres: element.nombres, identificacion: element.identificacion})
       });
       }
       
      }catch(error){console.log("eror parseo", error)}

      let nombresPaciente = `${responseTitulares.paciente.identificacion} - ${responseTitulares.paciente.primerApellido} ${responseTitulares.paciente.primerNombre}`
      personasToMsp.unshift({nombres:nombresPaciente, identificacion: responseTitulares.paciente.identificacion})
      
      console.log("despues de todo", personasToMsp)

      const responseCita = await procedimientosService.getByToken(this.tokenProceso);

      const urlMspMap = {
        0: responseCita.urlMspPaciente,
        1: responseCita.urlMspTitular1,
        2: responseCita.urlMspTitular2,
        3: responseCita.urlMspTitular3
      };

      this.itemsToMsp = personasToMsp.map( (t, index) => {

        return{
          identificacion: t.identificacion,
          nombre  : t.nombres,
          urlMsp  : urlMspMap[index],
          newMsp  : null,
          nTitular: index
        }
      });

    },



    prepararArchivosMsp(data){
      
      const mspPaciente = data.find( d => d.nTitular === 0 );
      const mspTitular1 = data.find( d => d.nTitular === 1 );
      const mspTitular2 = data.find( d => d.nTitular === 2 );
      const mspTitular3 = data.find( d => d.nTitular === 3 );

      this.dataFilesToUpdate = {
        mspPaciente: mspPaciente,
        mspTitular1: mspTitular1,
        mspTitular2: mspTitular2,
        mspTitular3: mspTitular3
      };

      this.$store.commit('setFiles', this.dataFilesToUpdate);
    },



    async onSaveMsp(){

      const response = await this.$swal({
        title: '¿Estas seguro?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, guardar!',
        cancelButtonText: 'Cancelar'
      });

      if (!response.isConfirmed) return;

     

      const { mspPaciente, mspTitular1, mspTitular2, mspTitular3 } = this.dataFilesToUpdate;

      console.log("files to update", this.dataFilesToUpdate)
      
      let urlMspPaciente = mspPaciente?.urlMsp;
      let urlMspTitular1 = mspTitular1?.urlMsp;
      let urlMspTitular2 = mspTitular2?.urlMsp;
      let urlMspTitular3 = mspTitular3?.urlMsp;

     

      if(mspPaciente?.newMsp)
        urlMspPaciente = await fileService.upload('mspProcesos', mspPaciente.newMsp, mspPaciente.identificacion, mspPaciente.urlMsp);

      if(mspTitular1?.newMsp)
        urlMspTitular1 = await fileService.upload('mspProcesos', mspTitular1.newMsp, mspTitular1.identificacion, mspTitular1.urlMsp);
      
      if(mspTitular2?.newMsp)
        urlMspTitular2 = await fileService.upload('mspProcesos', mspTitular2.newMsp, mspTitular2.identificacion, mspTitular2.urlMsp);

      if(mspTitular3?.newMsp)
        urlMspTitular3 = await fileService.upload('mspProcesos', mspTitular3.newMsp, mspTitular3.identificacion, mspTitular3.urlMsp);




      const fieldsToUpdate = {
        urlMspPaciente : this.urlsMspsDelete.includes(urlMspPaciente) ? null : urlMspPaciente ,
        urlMspTitular1 : this.urlsMspsDelete.includes(urlMspTitular1) ? null : urlMspTitular1,
        urlMspTitular2 : this.urlsMspsDelete.includes(urlMspTitular2) ? null : urlMspTitular2,
        urlMspTitular3 : this.urlsMspsDelete.includes(urlMspTitular3) ? null : urlMspTitular3,
      };

      
      const responseUpdate = await procedimientosService.updateByToken(this.tokenProceso, fieldsToUpdate);

      if(!responseUpdate) {
        this.$swal({
          title: "Error al actualizar Msp",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });
        return;
      }

      await this.$swal({
        title: "Msp actualizado correctamente",
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok",
      });
      this.itemsToMsp = [];
      this.$router.go(0);
    }
  },


  computed: {

    disabledButtonUpdate(){
      return !this.itemsToMsp.find( d => d.newMsp );
    }
  },

  watch:{

    itemsToMsp: {
      deep: true,
      immediate: true,
      handler(newValue){
        this.prepararArchivosMsp(newValue);
      }
    },

    '$route.query.msp': {
      handler(newValue){
        if(!newValue) return;
        this.loadData();
      }
    }
  }
}
</script>
